import CryptoJS from "crypto-js";
// export const BASE_URL = "http://localhost:8101/api";
export const BASE_URL = "https://yorocrmapi.yorotechnologies.com/api";
export const secretKey = "mySuperSecretKey123!";
// export const Host_URL = "https://localhost:3001/"
export const Host_URL = "https://yorocrmdemo.yorotechnologies.com/";
// Socket server base URL (no /api)
export const SOCKET_URL = "https://yorocrmapi.yorotechnologies.com";

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(data, secretKey).toString().replace(/\//g, "");
};

// Function to Decrypt Data
export const decryptData = (encryptedData) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};
